var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _KeyringController_instances, _KeyringController_resolveTriaName;
import { PersistStorage } from '../storage/storage';
import WalletService from '../services/wallet';
import UserService from '../services/user';
import generatePassword from 'generate-password';
//@ts-ignore
import ObservableStore from 'obs-store';
import { decryptAES, encryptAES256, shamir, generateSHA256, combine } from '../utils/crypto';
import { TEMP_MEM_STORE, getConfigForShardStorage } from '../utils/constants';
import NONEVMService from '../services/nonevm';
//@ts-ignore
import crypto from '../core-lib/crypto';
import { Multichain } from '../utils/helper/multichain';
//@ts-ignore
import { Buffer } from '../core-lib/buffer';
import * as bip39 from 'bip39';
import dscAbi from '../interfaces/abis/dsc.json';
import { ethers } from 'ethers';
//@ts-ignore
import * as secrets from 'sss-tria';
import DIDService from '../services/did';
import { AuthController, isEvmChain, UserController } from '@tria-sdk/core';
import IPFSService from '@tria-sdk/core/dist/services/ipfs';
import * as Sentry from '@sentry/browser';
import * as nacl from 'tweetnacl';
import * as naclUtil from 'tweetnacl-util';
import packageJson from '../package.json';
// 1. Extending Multichain only for getSigner for evmChainData for did creation
export class KeyringController extends Multichain {
    /**
     * Constructs a new instance of the Tria class.
     * @param apiUrl - The URL of the API.
     */
    constructor({ baseUrl, walletType, sentryDns, environment }) {
        super(baseUrl, walletType);
        _KeyringController_instances.add(this);
        this.apiUrl = baseUrl;
        this.store = new PersistStorage();
        this.nonEVMService = new NONEVMService(this.apiUrl);
        this.walletService = new WalletService(this.apiUrl);
        this.userService = new UserService(this.apiUrl);
        this.didService = new DIDService(this.apiUrl);
        this.authController = new AuthController(this.apiUrl);
        this.userController = new UserController(this.apiUrl);
        this.ipfsService = new IPFSService(this.apiUrl);
        this.environment = environment || 'mainnet';
        if (sentryDns) {
            console.log('sentryDns', sentryDns);
            Sentry.init({
                dsn: sentryDns,
                release: `tria-sdk/web@${packageJson.version}`,
                debug: true,
            });
        }
        // const oldMemData = this.store.getValue(TEMP_MEM_STORE);
        // this.store.removeValue(TEMP_MEM_STORE);
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const init = this.store.getValue('init');
            const { loginType, triaName, socialName, userId, input } = init;
            const tempVault = this.store.getValue('tempVault');
            const accessToken = this.store.getValue('accessToken');
            // console.log('tempVault', tempVault);
            if (tempVault) {
                const data = yield this.authController.getKey(accessToken);
                try {
                    const cipherText = tempVault.split(':')[1];
                    const iv = tempVault.split(':')[0];
                    const decryptedVault = yield decryptAES(cipherText, Buffer.from(data.key, 'hex'), Buffer.from(iv, 'hex'));
                    this.memStore = new ObservableStore(decryptedVault);
                    const { hashLocalKey, shard2LocalKey } = this.getLocalKeys({
                        loginType,
                        triaName,
                        socialName,
                        userId,
                        input,
                    });
                    if (this.store.getValue(hashLocalKey)) {
                        this.deleteShardAfterSaved({
                            hash: this.store.getValue(hashLocalKey),
                            localStorageKeyForHash: hashLocalKey,
                            localStorageKeyForShard2: shard2LocalKey,
                        });
                    }
                    // console.log('this.memStore', JSON.parse(this.memStore.getState()));
                }
                catch (err) {
                    console.log('err', err);
                    throw err;
                }
            }
            else {
                console.log('Please login again');
                this.memStore = new ObservableStore({
                    vault: {},
                });
            }
        });
    }
    getLocalKeys({ loginType, triaName, socialName, userId, input }) {
        switch (loginType) {
            case 'native':
                if (triaName) {
                    const shard2LocalKey = `${triaName}:native:$2`;
                    const hashLocalKey = `${triaName}:native:hash`;
                    return { shard2LocalKey, hashLocalKey };
                }
                else {
                    throw new Error('TriaName Required for native');
                }
            case 'otp':
                if (input) {
                    const shard2LocalKey = `${input}:otp:$2`;
                    const hashLocalKey = `${input}:otp:hash`;
                    return { shard2LocalKey, hashLocalKey };
                }
                else {
                    throw new Error('Input Required for Otp creation method');
                }
            case 'link':
                if (input) {
                    const shard2LocalKey = `${input}:link:$2`;
                    const hashLocalKey = `${input}:link:hash`;
                    return { shard2LocalKey, hashLocalKey };
                }
                else {
                    throw new Error('Input Required for link creation method');
                }
            case 'social':
                if (socialName && userId) {
                    const shard2LocalKey = `${socialName}:${userId}:$2`;
                    const hashLocalKey = `${socialName}:${userId}:hash`;
                    return { shard2LocalKey, hashLocalKey };
                }
                else {
                    throw new Error('socialName && userId Social method');
                }
            default:
                throw new Error(`Invalid Login Type: ${loginType}`);
        }
    }
    generateNewPassword() {
        const newPassword = generatePassword.generate({
            length: 12, // Adjust the desired length
            numbers: true, // Include numbers
            symbols: true, // Include special characters
            uppercase: true, // Include uppercase letters
            excludeSimilarCharacters: true, // Exclude similar characters (e.g., 'i', 'l', '1', 'L', etc.)
        });
        return newPassword;
    }
    /**
     * @version 2
     * @description use to generate the vault so that it can be call sepreately for DID creation
     */
    generateVault(triaName, importedMnemonic) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // console.log(triaName, importedMnemonic);
                // console.log('generating mnemonic');
                const mnemonic = importedMnemonic || bip39.generateMnemonic();
                // console.log('mnemonic');
                // const mnemonic = 'design large bone swallow frost wisdom evoke bike lunch okay report tomato';
                const wallet = ethers.Wallet.fromMnemonic(mnemonic, `m/44'/60'/0'/0/0`);
                // const encryptionPublicKey = await this.getEncryptionPublicKey(wallet.privateKey);
                const publicVault = {
                    triaName,
                    evm: {
                        address: wallet.address,
                        publicKey: wallet.publicKey,
                        // encryptionPublicKey,
                    },
                };
                const vault = {
                    triaName: triaName,
                    mnemonic: mnemonic,
                    evm: {
                        address: wallet.address,
                        privateKey: wallet.privateKey,
                    },
                };
                return { vault, publicVault };
            }
            catch (err) {
                console.error(err);
                Sentry.captureException(err, {
                    tags: { key: 'generateVault' },
                });
                throw err;
            }
        });
    }
    getEncryptionPublicKey(secretKey) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const skBuff = new Uint8Array(Buffer.from(secretKey, 'hex'));
                const keyPair = nacl.box.keyPair.fromSecretKey(skBuff);
                const publicKey = naclUtil.encodeBase64(keyPair.publicKey);
                return publicKey;
            }
            catch (e) {
                throw e;
            }
        });
    }
    getSigner(chainName, privateKey) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const chainInstance = this.chains[chainName];
            let signer, triaName, address;
            if (((_a = this.walletType) === null || _a === void 0 ? void 0 : _a.embedded) || !this.walletType) {
                // console.log('embedded walet with password');
                if (!privateKey) {
                    ({ privateKey, triaName, address } = yield __classPrivateFieldGet(this, _KeyringController_instances, "m", _KeyringController_resolveTriaName).call(this, chainName));
                    // console.log({ privateKey });
                }
                if (privateKey) {
                    // @ts-ignore
                    ({ signer } = yield chainInstance.getSigner(privateKey));
                }
                else
                    throw Error('Please login again, unable to fetch private key from tempVault');
            }
            else {
                // @ts-ignore
                ({ signer } = yield chainInstance.getSigner());
                address = yield signer.getAddress();
                triaName = null;
            }
            return { signer, chainInstance, triaName, address, privateKey };
        });
    }
    /**
     * @version 2
     * @description use to generate the evmChainData for did
     */
    generateEVMChainData(vault) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const evmAddress = ethers.utils.getAddress(vault.evm.address);
            const evmMessage = {
                address: evmAddress,
                timestamp: new Date().getTime(),
            };
            const chainName = this.environment == 'testnet' ? 'MUMBAI' : 'POLYGON';
            const { signer, chainInstance } = yield this.getSigner(chainName, (_a = vault === null || vault === void 0 ? void 0 : vault.evm) === null || _a === void 0 ? void 0 : _a.privateKey);
            // @ts-ignore
            const signature = yield chainInstance.signMessage(signer, JSON.stringify(evmMessage));
            return {
                address: evmAddress,
                message: evmMessage,
                signature,
            };
        });
    }
    /**
     * @version 2
     * @description native wallet creation using triaName and password
     * @todo Push shard to contract using relayer
     */
    createAccount({ triaName, password, mnemonic, origin, }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!triaName && !password) {
                    throw Error('TriaName and Password Required');
                }
                //checking DID exist or not
                let isAvailable = yield this.didService.checkDID(triaName);
                if (!isAvailable) {
                    throw Error('DID not Available!');
                }
                const { vault, publicVault } = yield this.generateVault(triaName, mnemonic);
                const evmChainData = yield this.generateEVMChainData(vault);
                // DID creation
                const args = {
                    did: triaName,
                    evmChainData: evmChainData,
                    nonEvmChainsData: [],
                };
                let res = (yield this.didService.createDID(args));
                if (!res.success) {
                    throw Error('DID creation failed!');
                }
                const dsc_key = generateSHA256(`${triaName}:${password}`);
                const shard1LocalKey = `${triaName}:native:$1`;
                const shard2LocalKey = `${triaName}:native:$2`;
                const hashLocalKey = `${triaName}:native:hash`;
                const ress = yield this.shardAndPushTheVault({
                    vault: vault,
                    dsc_hash: dsc_key,
                    password: password,
                    shard1LocalKey: shard1LocalKey,
                    shard2LocalKey: shard2LocalKey,
                    hashLocalKey: hashLocalKey,
                });
                // shard management
                // will replace this my secure random number
                if (ress.success) {
                    this.storeInTriaStore(publicVault);
                    this.store.setValue('init', JSON.stringify({ loginType: 'native', triaName, socialName: '', userId: '', input: '' }));
                    this.storeConnectedAppInSession(origin);
                    yield this.deleteShardAfterSaved({
                        hash: dsc_key,
                        localStorageKeyForShard2: shard2LocalKey,
                        localStorageKeyForHash: hashLocalKey,
                    });
                    this.postMessage({
                        type: 'Tria Sign up',
                        success: true,
                        data: publicVault,
                    });
                    // await this.generateUserSession({ vault: vault });
                    return { success: true, data: publicVault };
                }
                else {
                    throw ress.error;
                }
            }
            catch (err) {
                console.error(err);
                Sentry.captureException(err, {
                    tags: { key: 'createAccount' },
                });
                this.postMessage({
                    type: 'Tria Sign up',
                    success: false,
                    data: { triaName, message: err.message || 'Error signing up, please try again!' },
                });
                throw err;
            }
        });
    }
    /**
     * @version 2
     * @description For wallet creation using socails
     * @todo verify user already exist ONCHAIN
     * @todo Push shard to contract using relayer
     */
    socialogin({ triaName, password, platform, userId, isPasswordLess, accessToken, origin, pin, fromClientId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // console.log('keyring socialogin', { triaName, password, platform, userId, isPasswordLess });
                let isAvailable = yield this.didService.checkDID(triaName);
                if (!isAvailable) {
                    throw Error('DID not Available!');
                }
                if (isPasswordLess) {
                    password = this.generateNewPassword();
                    // console.log('generated password', password);
                }
                const { vault, publicVault } = yield this.generateVault(triaName);
                const evmChainData = yield this.generateEVMChainData(vault);
                // DID creation
                const args = {
                    did: triaName,
                    evmChainData: evmChainData,
                    nonEvmChainsData: [],
                };
                let res = (yield this.didService.createDID(args));
                if (!res.success) {
                    throw Error('DID creation failed!');
                }
                yield this.userController.fundWallet({ walletAddress: vault.evm.address, origin });
                const dsc_key = generateSHA256(`${userId}:${password}`);
                const shard1LocalKey = `${platform}:${userId}:$1`;
                const shard2LocalKey = `${platform}:${userId}:$2`;
                const hashLocalKey = `${platform}:${userId}:hash`;
                // const oauthData: OAuthDataArgs = {
                //   userOauthId: userId,
                //   success: true,
                //   isPasswordRequired: !isPasswordLess,
                //   password: isPasswordLess ? password : '',
                // };
                const { success, error, encyRandomNumber, recoveryShard, salt } = yield this.shardAndPushTheVault({
                    vault: vault,
                    dsc_hash: dsc_key,
                    password: password,
                    shard1LocalKey: shard1LocalKey,
                    shard2LocalKey: shard2LocalKey,
                    hashLocalKey: hashLocalKey,
                });
                if (success) {
                    if (!encyRandomNumber || !recoveryShard || !salt) {
                        throw new Error('Error in Sharding');
                    }
                    console.log('userId', userId);
                    const triaNameHash = generateSHA256(triaName);
                    if (!pin) {
                        pin = `${Math.floor(100000 + Math.random() * 900000)}`;
                    }
                    yield this.authController.saveOauthUser({
                        triaNameHash: triaNameHash,
                        triaName: triaName,
                        pin: pin,
                        encyRandomNumber: encyRandomNumber,
                        salt: salt,
                        shard: recoveryShard,
                        userOauthId: userId,
                        isPasswordRequired: !isPasswordLess,
                        password: isPasswordLess ? password : '',
                        platform: platform,
                        accessToken: accessToken,
                        fromClientId: fromClientId,
                    });
                    const initValue = JSON.stringify({
                        loginType: 'social',
                        triaName,
                        socialName: platform,
                        userId,
                        input: '',
                    });
                    this.storeInTriaStore(publicVault);
                    this.store.setValue('init', initValue);
                    this.storeConnectedAppInSession(origin);
                    const { tempVault } = yield this.generateUserSession({
                        vault: vault,
                        accessToken: accessToken,
                    });
                    yield this.sendToAuth(tempVault, initValue, JSON.stringify(publicVault), accessToken);
                    this.postMessage({
                        type: 'Social Sign up',
                        success: true,
                        data: publicVault,
                    }, true);
                    this.storeInTriaStore(publicVault);
                    this.userController.uploadGreenfield({ triaName });
                    return { success: true, data: vault.evm.address };
                }
                else {
                    throw error;
                }
            }
            catch (err) {
                console.error(err);
                //@ts-ignore
                Sentry.captureException(err, {
                    tags: { key: 'socialogin' },
                    extra: {
                        triaName,
                        userId,
                        platform,
                        origin,
                    },
                });
                this.postMessage({
                    type: 'Social Sign up',
                    success: false,
                    data: { triaName, message: err.message || 'Error signing up, please try again!' },
                }, true);
                return { success: false, data: null };
            }
        });
    }
    /**
     * @description Get the account
     * @param triaName triaName for native users
     * @param password password required for encrypt/decrypt in native case user will enter password and in all other case tria managing
     * @param userId In social login
     * @param socialName platform name twitter, google ...
     * @param input email or phone number in case of OTP login otherwise provide null
     * @param hash hash from the server in case of OTP login
     */
    getVault({ triaName, password, userId, socialName, input, hash, link, native, origin, accessToken, idToken, pin, }) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const startTime = performance.now();
                let dsc_key, salt, localShardKeyName, localSaltKeyName, localEncRandomNumberKeyName;
                if (userId) {
                    localShardKeyName = `${socialName}:${userId}:$1`;
                    localSaltKeyName = `SALT:${socialName}:${userId}:$`;
                    localEncRandomNumberKeyName = `encyRandomNumber:${socialName}:${userId}:$`;
                    dsc_key = generateSHA256(`${userId}:${password}`);
                }
                else if (triaName && native) {
                    localShardKeyName = `${triaName}:native:$1`;
                    localSaltKeyName = `SALT:${triaName}:native:$`;
                    localEncRandomNumberKeyName = `encyRandomNumber:${triaName}:native:$`;
                    dsc_key = generateSHA256(`${triaName}:${password}`);
                }
                else if (input && !link) {
                    localShardKeyName = `${input}:otp:$1`;
                    localSaltKeyName = `SALT:${input}:otp:$`;
                    localEncRandomNumberKeyName = `encyRandomNumber:${input}:otp:$`;
                    dsc_key = hash;
                }
                else if (input && link) {
                    localShardKeyName = `${input}:link:$1`;
                    localSaltKeyName = `SALT:${input}:link:$`;
                    localEncRandomNumberKeyName = `encyRandomNumber:${input}:link:$`;
                    dsc_key = hash;
                }
                salt = this.store.getValue(localSaltKeyName || '');
                const { DSC_ADDRESS, RPC_URL } = getConfigForShardStorage(this.environment);
                const provider = new ethers.providers.JsonRpcProvider(RPC_URL);
                const contract = new ethers.Contract(DSC_ADDRESS, dscAbi, provider);
                let ipfsPath = yield contract.hashToLink(dsc_key);
                console.log('ipfsPath', ipfsPath);
                let encRandomNumber;
                //Getting IPFS path from localstorage in case storage tx didn't successed
                if (!ipfsPath) {
                    if (userId) {
                        ipfsPath = this.store.getValue(`${socialName}:${userId}:$2`);
                    }
                    else if (triaName && native) {
                        ipfsPath = this.store.getValue(`${triaName}:native:$2`);
                    }
                    else if (input && !link) {
                        ipfsPath = this.store.getValue(`${input}:otp:$2`);
                    }
                    else if (input && link) {
                        ipfsPath = this.store.getValue(`${input}:link:$2`);
                    }
                }
                encRandomNumber = this.store.getValue(localEncRandomNumberKeyName || '');
                let lshard = (_a = this.store.getValue(localShardKeyName || '')) === null || _a === void 0 ? void 0 : _a.encyShard;
                //MIGRATION code for old account to Recovery shard
                // if (userId) {
                //   const { isRecoveryShardSetup } = await this.userController.isRecoveryShardSetup(
                //     accessToken
                //   );
                //   if (salt && encRandomNumber && lshard && !isRecoveryShardSetup) {
                //     const pin = `${Math.floor(100000 + Math.random() * 900000)}`;
                //     await this.userController.setupRecoveryShard({
                //       pin: pin,
                //       accessToken: accessToken,
                //       derivedKeySalt: salt,
                //       encyRandomNumber: encRandomNumber,
                //       shard: lshard,
                //     });
                //   }
                // }
                // GETTING USER RECOVERY SHARD WHEN LOCALSHARD IS NOT PRESENT
                if ((!salt || !encRandomNumber || !lshard) && accessToken) {
                    const res = yield this.authController.getRecoveryShard({ accessToken, idToken, pin });
                    this.store.setValue(localShardKeyName || `localShardKeyName:undefine`, JSON.stringify({
                        encyShard: res.data.shard,
                    }));
                    this.store.setValue(localEncRandomNumberKeyName || `localEncRandomNumberKeyName:undefine`, res.data.encyRandomNumber);
                    this.store.setValue(localSaltKeyName || `localSaltKeyName:undefine`, res.data.salt);
                    salt = res.data.salt;
                    encRandomNumber = res.data.encyRandomNumber;
                    lshard = res.data.shard;
                }
                const ipfsShard = yield this.ipfsService.fetchIPFSData(ipfsPath);
                const encryptedVault = secrets.hex2str(combine([lshard, ipfsShard]));
                let derivedKey = crypto.pbkdf2Sync(password, salt.toString('hex'), 5000, 32, 'sha512');
                let decRandomNumber = yield decryptAES(encRandomNumber.split(':')[1], derivedKey, Buffer.from(encRandomNumber.split(':')[0], 'hex'));
                decRandomNumber = decRandomNumber.replace(/^"|"$/g, '');
                const decryptedData = yield decryptAES(encryptedVault.split(':')[1], Buffer.from(decRandomNumber, 'hex'), Buffer.from(encryptedVault.split(':')[0], 'hex'));
                const vault = JSON.parse(decryptedData);
                const publicVault = {
                    triaName: vault === null || vault === void 0 ? void 0 : vault.triaName,
                    evm: { address: (_b = vault === null || vault === void 0 ? void 0 : vault.evm) === null || _b === void 0 ? void 0 : _b.address },
                };
                let initValue;
                if (userId) {
                    initValue = JSON.stringify({
                        loginType: 'social',
                        triaName,
                        socialName: socialName,
                        userId,
                        input: '',
                    });
                }
                else if (triaName && native) {
                    initValue = JSON.stringify({
                        loginType: 'native',
                        triaName,
                        socialName: '',
                        userId: '',
                        input: '',
                    });
                }
                else if (input && !link) {
                    initValue = JSON.stringify({
                        loginType: 'otp',
                        triaName,
                        socialName: '',
                        userId: '',
                        input,
                    });
                }
                else if (input && link) {
                    initValue = JSON.stringify({
                        loginType: 'link',
                        triaName,
                        socialName: '',
                        userId: '',
                        input,
                    });
                }
                if (!initValue)
                    throw Error('Error: Init Value');
                this.store.setValue('init', initValue);
                this.storeInTriaStore(publicVault);
                this.storeConnectedAppInSession(origin);
                const { tempVault } = yield this.generateUserSession({
                    vault: vault,
                    accessToken: accessToken,
                });
                yield this.sendToAuth(tempVault, initValue, JSON.stringify(publicVault), accessToken);
                const endTime = performance.now();
                const executionTime = endTime - startTime;
                console.log(`Execution time: ${executionTime / 1000} seconds`);
                this.userController.fetchGreenfield({ triaName: publicVault.triaName });
                return { exists: true, data: vault, publicVault };
            }
            catch (err) {
                console.error(err);
                Sentry.captureException(err, {
                    tags: { key: 'getVault' },
                    extra: {
                        triaName,
                        userId,
                        socialName,
                        input,
                        origin,
                    },
                });
                this.postMessage({
                    type: 'Log in',
                    success: false,
                    data: { triaName, message: err.message || 'Incorrect username or password' },
                }, userId || socialName ? true : false);
                return { exists: false, data: null, publicVault: null };
            }
        });
    }
    /**
     * @version 2
     */
    initiateCognitoAuth({ input, password, origin, isPasswordLess, verificationType, fromClientId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.authController.initiateCognitoAuth({
                input,
                password,
                origin,
                isPasswordLess,
                verificationType,
                fromClientId,
            });
            return res;
        });
    }
    /**
     * @version 2
     */
    verifyCognitoAuth({ code, input, isPasswordLess, session, verificationType, fromClientId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { verify } = yield this.authController.verifyCognitoAuth({
                    code,
                    input,
                    isPasswordLess,
                    session,
                    verificationType,
                    fromClientId,
                });
                return { verify };
            }
            catch (err) {
                console.error(err);
                Sentry.captureException(err, {
                    tags: { key: 'verifyCognitoAuth' },
                    extra: {
                        input,
                        isPasswordLess,
                        verificationType,
                    },
                });
            }
        });
    }
    /**
     * @version 2
     * @param hash We get from backend
     * @param input user email or phone number
     * @param password to encrypt the data will get from backend
     * @param triaName users triaName
     * @param type ["LINK", "OTP"]
     *
     */
    generateAccountByOTPOrLINK({ hash, input, password, triaName, type, origin, accessToken, IdToken, fromClientId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const TYPES = ['link', 'otp'];
            if (!TYPES.includes(type)) {
                throw new Error('Invalid account creation method');
            }
            const { vault, publicVault } = yield this.generateVault(triaName);
            const evmChainData = yield this.generateEVMChainData(vault);
            // DID creation
            const args = {
                did: triaName,
                evmChainData: evmChainData,
                nonEvmChainsData: [],
            };
            let res = (yield this.didService.createDID(args));
            if (!res.success) {
                throw Error('DID creation failed!');
            }
            yield this.userController.fundWallet({ walletAddress: vault.evm.address, origin });
            const shard1LocalKey = `${input}:${type}:$1`;
            const shard2LocalKey = `${input}:${type}:$2`;
            const hashLocalKey = `${input}:${type}:hash`;
            const { encyRandomNumber, success, error, recoveryShard, salt } = yield this.shardAndPushTheVault({
                vault,
                dsc_hash: hash,
                password,
                shard1LocalKey,
                shard2LocalKey: shard2LocalKey,
                hashLocalKey: hashLocalKey,
            });
            if (!encyRandomNumber) {
                // console.log({ encyRandomNumber });
                throw Error('Error while generating random number');
            }
            if (success) {
                yield this.userController.postAccountCreationData(triaName, accessToken, encyRandomNumber, recoveryShard, salt, IdToken, input, fromClientId);
                const initValue = JSON.stringify({
                    loginType: type,
                    triaName,
                    socialName: '',
                    userId: '',
                    input,
                });
                this.storeInTriaStore(publicVault);
                this.store.setValue('init', initValue);
                this.storeConnectedAppInSession(origin);
                // this.postMessage({
                //   type: `${type} Sign up`,
                //   success: true,
                //   data: publicVault,
                // });
                const { tempVault } = yield this.generateUserSession({ vault: vault, accessToken });
                // this.sendToAuth(tempVault, initValue, JSON.stringify(publicVault), accessToken);
                this.userController.uploadGreenfield({ triaName });
                return { success: true };
            }
            else {
                Sentry.captureException(error, {
                    tags: { key: 'verifyCognitoAuth' },
                    extra: {
                        input,
                        triaName,
                        origin,
                    },
                });
                throw error;
            }
        });
    }
    /**
     * @description shard the vault and call the ShardStorage api
     */
    shardAndPushTheVault({ vault, dsc_hash, password, shard1LocalKey, shard2LocalKey, oauthData, hashLocalKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const salt = crypto.randomBytes(16);
                const randomNumber = crypto.randomBytes(32);
                // console.log('password', password);
                let derivedKey = crypto.pbkdf2Sync(password, salt.toString('hex'), 5000, 32, 'sha512');
                // console.log('randomNumber.toString', JSON.stringify(randomNumber.toString('hex')));
                // console.log('derivedKey', derivedKey.toString('hex'));
                const encryptedRandomNumber = encryptAES256(derivedKey, JSON.stringify(randomNumber.toString('hex')));
                this.store.setValue(`encyRandomNumber:${shard1LocalKey.slice(0, -1)}`, encryptedRandomNumber);
                // enctrypt the vault
                const encryptedWallet = encryptAES256(randomNumber, JSON.stringify(vault));
                // shard the encrypted vault
                const [lshard, ipfsShard, recoveryShard] = shamir(secrets.str2hex(encryptedWallet), 3, 2);
                const lstore = {
                    encyShard: lshard,
                };
                const ipfsPath = yield this.ipfsService.pinToIpfs(ipfsShard);
                // save the shard to local storage
                this.store.setValue(shard1LocalKey, JSON.stringify(lstore));
                this.store.setValue(shard2LocalKey, JSON.stringify(ipfsPath));
                this.store.setValue(hashLocalKey, JSON.stringify(dsc_hash));
                this.store.setValue(`SALT:${shard1LocalKey.slice(0, -1)}`, JSON.stringify(salt.toString('hex')));
                // call the shard storage
                let shardStorageRes = (yield this.didService.shardStorage({
                    hash: dsc_hash,
                    link: ipfsPath,
                }));
                if (!shardStorageRes.success) {
                    throw Error('DID creation failed!');
                }
                return {
                    success: true,
                    salt: salt.toString('hex'),
                    encyRandomNumber: encryptedRandomNumber,
                    recoveryShard: recoveryShard,
                };
            }
            catch (err) {
                Sentry.captureException(err, {
                    tags: { key: 'shardAndPushTheVault' },
                });
                return { success: false, error: err };
            }
        });
    }
    /**
     * @description delete shard
     */
    deleteShardAfterSaved({ hash, localStorageKeyForHash, localStorageKeyForShard2, }) {
        return __awaiter(this, void 0, void 0, function* () {
            let intervalID = setInterval(() => __awaiter(this, void 0, void 0, function* () {
                let shardElement = yield this.isShardPresent(hash);
                if (shardElement) {
                    console.log('Shard is present!');
                    //delete data from localStorage
                    this.store.removeValue(localStorageKeyForHash);
                    this.store.removeValue(localStorageKeyForShard2);
                    clearInterval(intervalID);
                }
                else {
                    console.log('Shard is not saved yet');
                }
            }), 10000);
        });
    }
    /**
     * @version 2
     * @returns Boolean
     */
    isShardPresent(hash) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let shardExistsResponse = (yield this.didService.shardExists(hash));
                if (!shardExistsResponse.success) {
                    throw Error('Check Shard API Error!');
                }
                return shardExistsResponse.response;
            }
            catch (err) {
                throw err;
            }
        });
    }
    /**
     *
     */
    generateUserSession({ vault, accessToken }) {
        return __awaiter(this, void 0, void 0, function* () {
            //api request for cookie set and it will return key too
            const { key } = yield this.authController.getKey(accessToken);
            // console.log('key', key);
            const keyBytes = Buffer.from(key, 'hex');
            // store the decrypted vault in obsStore
            this.memStore = new ObservableStore({
                vault: vault,
            });
            //use the key and salt to encrypt the vault
            const encryptedVault = encryptAES256(keyBytes, JSON.stringify(vault));
            //store the encrypted vault in localstorage for now
            this.store.setValue('tempVault', JSON.stringify(encryptedVault));
            return { tempVault: JSON.stringify(encryptedVault) };
        });
    }
    detectLoggedInAccount() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let vault = (_a = this.memStore) === null || _a === void 0 ? void 0 : _a.getState();
            vault = JSON.parse(vault);
            const account = { triaName: vault === null || vault === void 0 ? void 0 : vault.triaName, evm: { address: (_b = vault === null || vault === void 0 ? void 0 : vault.evm) === null || _b === void 0 ? void 0 : _b.address } };
            this.postMessage({
                type: 'Detected Logged in Tria account',
                success: true,
                data: account,
            });
        });
    }
    /**
     *@description this function is for inMemory data persist
     */
    persistMemoryData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.store.setValue(TEMP_MEM_STORE, JSON.stringify(this.memStore.getState()));
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.authController.logout();
            this.cleanOnLogout();
            this.postMessage({
                type: 'Logout',
                success: true,
            });
            return { success: true };
        });
    }
    cleanOnLogout() {
        return __awaiter(this, void 0, void 0, function* () {
            this.store.removeValue('tempVault');
            this.store.removeValue('tria.wallet.store');
            this.memStore = new ObservableStore({});
            return { success: true };
        });
    }
    /**
     * @param triaName triaName
     * @param chainName chainName
     */
    resolveTriaName(triaName, chainName) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.walletService.resolveTriaName({ chainName, lookUpTriaName: triaName }, this.environment);
            return res.address;
        });
    }
    /**
     * For message passing between windows and iframes
     * @param windowTo
     * @param message
     */
    postMessage(message, sameOrigin = false) {
        var _a, _b;
        try {
            // console.log('postMessage', message);
            // console.log({ sameOrigin });
            if (sameOrigin) {
                const bc = new BroadcastChannel('Tria Auth Channel');
                bc.postMessage(JSON.stringify(message));
                if ((_a = window === null || window === void 0 ? void 0 : window.opener) === null || _a === void 0 ? void 0 : _a.postMessage) {
                    window.opener.postMessage(JSON.stringify(message), '*');
                }
                return;
            }
            if ((_b = window === null || window === void 0 ? void 0 : window.opener) === null || _b === void 0 ? void 0 : _b.postMessage) {
                window.opener.postMessage(JSON.stringify(message), '*');
            }
            else if (window === null || window === void 0 ? void 0 : window.parent) {
                window.parent.postMessage(JSON.stringify(message), document.referrer);
            }
        }
        catch (err) {
            console.error(err);
        }
    }
    storeInTriaStore(publicVault) {
        this.store.setValue('tria.wallet.store', JSON.stringify(publicVault));
    }
    sendToAuth(tempVault, initValue, publicVault, accessToken) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            var sBrowser, sUsrAg = window.navigator.userAgent;
            let isFirefox = false;
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            console.log('Is safari?', isSafari);
            if (sUsrAg.indexOf('Firefox') > -1) {
                sBrowser = 'Mozilla Firefox';
                console.log('Browser: Firefox');
                isFirefox = true;
            }
            // @ts-ignore
            var isBrave = (((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.brave) && (yield ((_c = (_b = window.navigator) === null || _b === void 0 ? void 0 : _b.brave) === null || _c === void 0 ? void 0 : _c.isBrave()))) || false;
            if (isFirefox || isSafari || isBrave) {
                this.postMessage({
                    type: 'Save to Auth Iframe',
                    data: {
                        tempVault,
                        init: initValue,
                        publicVault,
                        accessToken,
                    },
                }, true);
            }
        });
    }
    storeConnectedAppInSession(dappUrl) {
        const connectedApps = 'tria.connected.apps';
        try {
            const appUrl = dappUrl || document.referrer;
            let prevApps = window.localStorage.getItem(connectedApps);
            let allApps;
            if (prevApps) {
                // console.log(prevApps);
                const apps = JSON.parse(prevApps);
                // to avoid duplicates
                if (apps.includes(appUrl))
                    return;
                apps.push(appUrl);
                allApps = JSON.stringify(apps);
            }
            else {
                allApps = JSON.stringify([appUrl]);
            }
            // console.log({ allApps });
            window.localStorage.setItem(connectedApps, allApps);
        }
        catch (err) {
            window.localStorage.removeItem(connectedApps);
        }
    }
}
_KeyringController_instances = new WeakSet(), _KeyringController_resolveTriaName = function _KeyringController_resolveTriaName(chainName) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        // console.log('fetching vault');
        let vault = yield ((_a = this.memStore) === null || _a === void 0 ? void 0 : _a.getState());
        // console.log('await this.memStore?.getState()', vault);
        if (vault) {
            try {
                vault = JSON.parse(vault);
            }
            catch (err) { }
        }
        // console.log('JSON.parse(vault)', { vault });
        let privateKey, address;
        if (isEvmChain(chainName)) {
            privateKey = (_b = vault === null || vault === void 0 ? void 0 : vault.evm) === null || _b === void 0 ? void 0 : _b.privateKey;
            address = (_c = vault === null || vault === void 0 ? void 0 : vault.evm) === null || _c === void 0 ? void 0 : _c.address;
        } // else implement for non evm
        return {
            privateKey: privateKey,
            address: address,
            triaName: vault === null || vault === void 0 ? void 0 : vault.triaName,
        };
    });
};
